import React, { useEffect, useRef } from 'react';
import { withLeaflet } from 'react-leaflet';
import L from 'leaflet';
import { IImportedRouteStop } from '../../models/importedRouteStops';

interface RouteStopsLayerProps {
  leaflet: any;
  routeStops: IImportedRouteStop[];
  visible: boolean;
}

const RouteStopsLayer: React.FC<RouteStopsLayerProps> = ({
  leaflet,
  routeStops,
  visible,
}) => {
  const layerRef = useRef<L.LayerGroup | null>(null);

  useEffect(() => {
    layerRef.current = L.layerGroup();
    leaflet.map.addLayer(layerRef.current);

    return () => {
      leaflet.map.removeLayer(layerRef.current!);
    };
  }, [leaflet.map]);

  useEffect(() => {
    if (!layerRef.current) return;

    layerRef.current.clearLayers();

    if (!visible || !routeStops?.length) return;

    routeStops.forEach((stop) => {
      if (!stop.degLat || !stop.degLong) return;

      L.circleMarker([stop.degLat, stop.degLong], {
        radius: 5,
        fillColor: '#ff0000',
        color: '#ffffff',
        weight: 1,
        opacity: 1,
        fillOpacity: 0.9,
      }).addTo(layerRef.current!);
    });
  }, [routeStops, visible]);

  useEffect(() => {
    if (!visible || !routeStops?.length) return;

    const bounds = L.latLngBounds([]);

    routeStops.forEach((stop) => {
      if (!stop.degLat || !stop.degLong) return;
      bounds.extend([stop.degLat, stop.degLong]);
    });

    if (bounds.isValid()) {
      leaflet.map.fitBounds(bounds, {
        padding: [40, 40],
        maxZoom: 17,
      });
    }
  }, [routeStops, visible, leaflet.map]);

  return null;
};

export default withLeaflet(RouteStopsLayer);
